import { AbstractCommand } from 'src/models/command';

type MessageIdoLinking = {
	idoLinkings: {
		idoId: string;
		instanceId: string;
	}[];
};

class CreateMessageAndReturnMessageIdCommand extends AbstractCommand {
	readonly name = 'IFS_Message_Compose_Command_Commands_CreateMessageAndReturnMessageId';

	public constructor(idoLinking: MessageIdoLinking) {
		super();
		this.parameters = {
			messageAppConfiguration: idoLinking,
		};
	}
}

export { CreateMessageAndReturnMessageIdCommand };
